import { createGlobalStyle } from 'styled-components';

// Color palette
export const colors = {
  greenPrimary: '#007f3c',
  blueLight: '#00a1df',
  white: '#ffffff',
  grayLight: '#f5f6fa',
  grayDark: '#222222',
};

// Breakpoints for responsiveness
export const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px',
};

// Fonts
export const fonts = {
  primary: "'Inter', 'Roboto', sans-serif",
};

// Global styles including font import and resets
export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter&family=Roboto&display=swap');

  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: ${fonts.primary};
    background-color: ${colors.grayLight};
    color: ${colors.grayDark};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button {
    font-family: ${fonts.primary};
    cursor: pointer;
  }
`;
